"use client";

import { Stencil } from "components/Stencil";
import { Container } from "ct-design";

const FilterLoader = () => {
  return (
    <Container>
      <Stencil height={20} width={270} className="mr-12 br-4" shimmer />
      <Stencil height={1} width={270} className="mr-12 mt-5 br-24" shimmer />
      <Container className="mr-12">
        <Stencil height={20} width={270} className="mt-4 br-4" shimmer />
        <Container>
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
        </Container>
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-6 br-24" shimmer />
      <Stencil height={20} width={270} className="mr-12 mt-6 br-4" shimmer />
      <Container className="mr-4 mt-4">
        <Container className="flex">
          <Stencil height={32} width={64} className="br-90" shimmer />
          <Stencil height={32} width={97} className="ml-3 mr-3 br-90" shimmer />
          <Stencil height={32} width={88} className="br-90" shimmer />
        </Container>
        <Container className="mt-3 flex">
          <Stencil height={32} width={95} className="br-90" shimmer />
          <Stencil height={32} width={130} className="ml-3 br-90" shimmer />
        </Container>
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-6 br-24" shimmer />
      <Stencil height={20} width={270} className="mr-12 mt-6 br-4" shimmer />
      <Container className="mt-4 flex">
        <Stencil height={32} width={122} className="br-90" shimmer />
        <Stencil height={32} width={111} className="ml-3 br-90" shimmer />
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-5 br-24" shimmer />
      <Container className="mr-12">
        <Stencil height={20} width={270} className="mt-4 br-4" shimmer />
        <Container>
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
        </Container>
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-5 br-24" shimmer />
      <Container className="mr-12">
        <Stencil height={20} width={270} className="mt-4 br-4" shimmer />
        <Container>
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
        </Container>
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-5 br-24" shimmer />
      <Container className="mr-12">
        <Stencil height={20} width={270} className="mt-4 br-4" shimmer />
        <Container>
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
        </Container>
      </Container>
      <Stencil height={1} width={270} className="mr-12 mt-5 br-24" shimmer />
      <Container className="mr-12">
        <Stencil height={20} width={270} className="mt-4 br-4" shimmer />
        <Container>
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
          <Stencil height={24} width={208} className="mt-6 br-4" shimmer />
        </Container>
      </Container>
    </Container>
  );
};

export default FilterLoader;
